<div class="sub-header px-3">
    <!-- <app-breadcrumb [breadcrumbs]="breadcrumbs"></app-breadcrumb> -->
</div>
<div class="search-container py-3 align-items-center d-flex row px-3 mb-1 pb-4">
    <div class="col-md-5 catalog-header d-flex px-3 py-1">
        <h5 class="mb-0 px-0">AMD Location - Job-code Management</h5>
    </div>
    <div class="col-md-7 px-4 search-input-block d-flex align-items-center justify-content-end">
        <ng-container>
            <button nz-button nzType="primary" class="d-flex align-items-center" [nzSize]="'default'"
                (click)="linkDrawer = !linkDrawer">
                Add New Mapping
            </button>
        </ng-container>
    </div>

</div>
<div class="row d-flex justify-content-center align-items-center h-100" *ngIf="isLoading"><app-spinner></app-spinner></div>
<div [ngStyle]="{'height':amdArrData.length>0 ? '80vh': ''}"
    class="row p-0 mt-3 catalog-container justify-content-center  d-flex align-items-center" *ngIf="!isLoading">
    <div class="row p-0">
        <div class="col-md-12 row product-search-container p-3 mb-3 ml-5">
            <div class="col-md-4 mb-4 d-flex flex-column position-relative">

                <label class="form-label">Select Program <span class="text-danger">*</span></label>
                <nz-select nzPlaceHolder="Select" nzSize="default" [(ngModel)]="selectedProgram"
                    (ngModelChange)="getLocationList()" style="height: 35px !important;" >
                    @for(program of programList;track program){
                    <nz-option [nzLabel]="program" [nzValue]="program"></nz-option>
                    }

                </nz-select>
                <span class="error-text" *ngIf="invalidSearch && !selectedProgram">
                   * Program Selection is required.
                </span>
            </div>
            <div class="col-md-4 mb-4 d-flex flex-column position-relative">

                <label class="form-label">Select Location <span class="text-danger">*</span></label>
                <nz-select nzPlaceHolder="Select" nzSize="default" [(ngModel)]="selectedLocation"
                    style="height: 35px !important;">
                    @for(location of locationList;track location.locationId){
                    <nz-option [nzLabel]="location.locationCode" [nzValue]="location.locationCode"></nz-option>
                    }

                </nz-select>
                <span class="error-text" *ngIf="!selectedLocation && invalidSearch ">
                    * Location Selection is required.
                </span>
            </div>
            <div class="col-md-4 d-flex"
                >
                <button (click)="searchJobLocationCode()" nz-button nzType="primary" class="mt-2 d-flex align-items-center"
                    [nzSize]="'default'">
                    Search
                </button>
            </div>
        </div>
        <div class="px-2 py-4 col-md-12 amd-list-container">
               <div class="col-md-12 px-4 searh-input-block d-flex align-items-center justify-content-between ">
                <div class="col-md-6">
                    <nz-input-group class="px-2 mr-2 search-input-group" style="width: 80%;height: 35px;"
                        nzSize="default" [nzSuffix]="suffixIconSearch">
                        <input type="text" class="py-1" nz-input placeholder="Search For Job-code"
                            (keydown.enter)="searchLocation(SearchText.value)" [(ngModel)]="searchText" nzAllowClear
                            #SearchText />
                        <span class="close-icon" (click)="SearchText.value = '';searchLocation('')" class="px-1" nz-icon
                            nzType="close-circle"></span>

                    </nz-input-group>
                    <ng-template #suffixIconSearch>
                        <span class="search-icon" (click)="searchLocation(SearchText.value)" nz-icon
                            nzType="search"></span>
                    </ng-template>
                </div>
        <div class="d-flex">
            <button [disabled]="selectedAmdJobLoc.length==0" (click)="deleteSelected()" nz-button nzType="primary" class="d-flex align-items-center mr-5" [nzSize]="'default'">
                <span  nz-icon nzType="delete"></span>  Delete 
            </button>
            <button (click)="updateJobLocCode(toggledRows)" [disabled]="selectedProgram != 'AMD ALLOW' || toggledRows.length == 0 " nz-button nzType="primary" class="d-flex align-items-center" [nzSize]="'default'">
                Save
            </button>
        </div>
            </div>
        <ng-container>
            <app-data-grid (toggledRows)="toggledRow($event)" (selectedRows)="selectedRows($event)" (deleteRow)="deleteRow($event)" [columns]="amdColumns" [dataSet]="amdArrData" [gridStyle]="'white'"></app-data-grid>
        </ng-container>
        </div>
    </div>
</div>
<nz-drawer [nzMaskClosable]="false" [nzKeyboard]="false" [nzWidth]="1000" [nzVisible]="linkDrawer"
    nzTitle="Add AMD Location - Job-code Mapping" (nzOnClose)="linkDrawer = false">
    <ng-container *nzDrawerContent>
        <app-add-amd-job-allocate (emitData)="addRow($event)" [programList]="programList"></app-add-amd-job-allocate>
    </ng-container>
</nz-drawer>
<app-confirm-popup *ngIf="showModal" [title]="'Delete'" message="Are you sure to delete the selected AMD Location - Job-code association(s)?" confirmText="Delete"
  [triggerModal]="showModal" [cancelText]="'Cancel'" (confirm)="updateJobLocCode(payLoadData)"
  (cancel)="showModal =false;"></app-confirm-popup>